export enum DynamicLoaderAssets {
  Intercom = 'https://widget.intercom.io/widget/tnpm2lgx',
  ReCaptcha = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=ng2recaptchaloaded&hl={TOKEN}',
  TypeformSurveyScript = 'https://embed.typeform.com/next/embed.js',
}
